import { IMarketYoyGrowthExpectationApi } from '../api/types'
import { IMarketYoyGrowthExpectation } from '../model/types'

/**
 * `EntryId`/`UID` are included only when present (an update to an existing
 * row) — omitted for a phantom record with no backing fetched row (a
 * create). Audit fields (`Created`/`CreatedBy`/`Modified`/`ModifiedBy`) are
 * server-managed and never sent by the client.
 */
export const mapMarketYoyGrowthExpectationToApi = (
  record: IMarketYoyGrowthExpectation
): IMarketYoyGrowthExpectationApi => ({
  ...(record.entryId !== undefined ? { EntryId: record.entryId } : {}),
  ...(record.uid !== undefined ? { UID: record.uid } : {}),
  PlanningEntryID: record.planningEntryId,
  RTM: record.rtm,
  Market: record.market,
  Offering: record.offering,
  Category: record.productCategory,
  FinYoYGrowth: record.yoyGrowth,
  SobYoYGrowth: record.sobYoyGrowth,
  IsExpanded: record.isExpanded ? 1 : 0,
})
